module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/process/modal/process-modal.component.scss
// module id = ./src/app/pages/process/modal/process-modal.component.scss
// module chunks = main